import {Footer} from "../Footer";
import {Header} from "../Header";
import {Helmet} from "react-helmet";

export const FridgesPage = () => {
  
  return (
    <div className="container">
      <Helmet>
        <title>Sklep AGD - Lodówki</title>
      </Helmet>
    <Header />  
      
    <main className="mt-4">
      <h2>Lodówki</h2>
      <p className="my-4">
        W prawdziwym sklepie AGD znajdziesz szeroki wybór lodówek, ale tutaj nic nie ma bo to tylko sklep testowy.    
      </p>
    </main>
      
    <Footer />
      
  </div>
  );
  
}